import { CouponPackBase } from "../json-schemas/base/coupon_pack"
import { BackofficeCouponsPacksEditResponse } from "../json-schemas/serializers/backoffice-coupons-packs-edit-response"
import { BackofficeCouponsPacksNewResponse } from "../json-schemas/serializers/backoffice-coupons-packs-new-response"
import { CouponsPacksListResponse } from "../json-schemas/serializers/coupons-packs-list-response"
import { httpDelete, httpGet, httpGetRoute, httpPatch, httpPost } from "../utils/http.service"
import { I18nService } from "../utils/i18n.service"
import { formatDurationFromHours } from "../utils/utils.service"

export interface RansackQuery {
  'q[id_not_in][]'?: number[]
}

const i18nScoped = new I18nService(require('./coupons-packs.service.yml'))

export function couponsPackList (query: RansackQuery = {}):Promise<CouponsPacksListResponse> {
  return httpGet(`/${httpGetRoute()}/coupons_packs`, query)
}

export function couponsPackActivate (couponsPackId: CouponPackBase['id']) {
  return httpPatch(`/${httpGetRoute()}/coupons_packs/${couponsPackId}`, { coupons_pack: { active: true } })
}

export function couponsPackDeactivate (couponsPackId: CouponPackBase['id']) {
  return httpPatch(`/${httpGetRoute()}/coupons_packs/${couponsPackId}`, { coupons_pack: { active: false } })
}

export function couponsPackDelete (couponsPackId: CouponPackBase['id']) {
  return httpDelete(`/${httpGetRoute()}/coupons_packs/${couponsPackId}`)
}

export function couponsPackEdit (couponsPackId: CouponPackBase['id']): Promise<BackofficeCouponsPacksEditResponse> {
  return httpGet(`/${httpGetRoute()}/coupons_packs/${couponsPackId}/edit`)
}

export function couponsPackNew () : Promise<BackofficeCouponsPacksNewResponse> {
  return httpGet(`/${httpGetRoute()}/coupons_packs/new`)
}

export function couponsPackCreate (body: any) {
  return httpPost(`/${httpGetRoute()}/coupons_packs`, { coupons_pack: body })
}

export function couponsPackUpdate (body: any) {
  return httpPatch(`/${httpGetRoute()}/coupons_packs/${body.id}`, { coupons_pack: body })
}

export function couponsPackI18nActive (active: boolean) {
  return i18nScoped.t(`active.${active}`)
}

export function couponsPackI18nInUse (count: number) {
  return i18nScoped.t('in_use', { count })
}

export function couponsPackI18nValidityDurationInMonths (validityDurationInMonths: number | null) {
  if (validityDurationInMonths) return i18nScoped.t('validity_duration_in_months', { count: validityDurationInMonths })
  return i18nScoped.t('unlimited_valid')
}

export function couponsPackI18nPackOf (couponsPack: Pick<CouponPackBase, 'quantity'>) {
  return i18nScoped.t('pack_of', { quantity: formatDurationFromHours(couponsPack.quantity) })
}
